<template>
  <a-card :bordered="false">
    <!-- 検索区域 -->
    <div class="table-page-search-wrapper">
      <a-form-model layout="inline" @keyup.enter.native="searchQuery(false, false)">
        <a-row :gutter="24">
          <a-col :sm="24" :md="8" :lg="8" :xl="6" :xxl="5">
            <a-form-model-item label="关键字">
              <a-input
                :placeholder="$t('disp.ph.match', [$t('disp.jobName')])"
                v-model="queryParam.jobClassName"
              ></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :xs="1" :sm="1" class="width-fit-content">
            <a-form-model-item :wrapperCol="{ span: 24 }">
              <a-button type="primary" @click="searchQuery(false, false)" icon="search">{{
                $t('disp.btn.search')
              }}</a-button>
              <a-button @click="searchReset" icon="stop">{{ $t('disp.btn.reset') }}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <!-- ボタン操作区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('disp.btn.add') }}</a-button>
      <a-button v-if="selectedRowKeys.length > 0" @click="batchDel" icon="close">{{
        this.$t('disp.btn.deleteBatch')
      }}</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info div-selected-info">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        {{ this.$t('disp.selected') }}
        <a class="a-selected-info">{{ selectedRowKeys.length }}</a>
        {{ this.$t('disp.item') }}
        <a @click="onClearSelected">{{ this.$t('disp.clear') }}</a>
      </div>

      <a-table
        ref="table"
        class="action"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
        tableLayout="auto"
      >
        <div slot="action" slot-scope="text, record" style="white-space: nowrap">
          <a-popconfirm :title="$t('msg.confirm.startJob')" @confirm="() => resumeJob(record)">
            <a v-if="record.status == -1">{{ $t('disp.btn.start') }}</a>
          </a-popconfirm>

          <a-popconfirm :title="$t('msg.confirm.stopJob')" @confirm="() => pauseJob(record)">
            <a v-if="record.status == 0">{{ $t('disp.btn.stop') }}</a>
          </a-popconfirm>

          <a-divider type="vertical" />

          <a-popconfirm :title="$t('msg.confirm.excuteNow')" @confirm="() => executeImmediately(record)">
            <a>{{ $t('disp.btn.excuteNow') }}</a>
          </a-popconfirm>

          <a-divider type="vertical" />

          <a @click="handleEdit(record)">{{ $t('disp.btn.edit') }}</a>

          <a-divider type="vertical" />

          <a-popconfirm :title="$t('msg.confirm.delete')" @confirm="() => handleDelete(record.id)">
            <a>{{ $t('disp.btn.delete') }}</a>
          </a-popconfirm>
          <!-- <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item><a @click="executeImmediately(record)">立即执行</a></a-menu-item>
              <a-menu-item><a @click="handleEdit(record)">编辑</a></a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </div>

        <!-- ステータスレンダリングテンプレート -->
        <div slot="customRenderStatus" slot-scope="text, record">
          <a-tag v-if="record.status == 0" color="green">{{ $getDict('quartz_status', record.status) }}</a-tag>
          <a-tag v-if="record.status == -1" color="orange">{{ $getDict('quartz_status', record.status) }}</a-tag>
        </div>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- フォーム区域 -->
    <quartzJob-modal ref="modalForm" @ok="modalFormOk"></quartzJob-modal>
  </a-card>
</template>

<script>
import QuartzJobModal from './modules/QuartzJobModal'
import { getAction } from '@/api/manage'
import { tableMixin } from '@/mixins/tableMixin'

export default {
  name: 'QuartzJobManage',
  mixins: [tableMixin],
  components: {
    QuartzJobModal,
  },
  data() {
    return {
      description: '定期JOB管理',
      // 検索条件
      queryParam: {},
      // テーブルタイトル
      columns: [
        //{
        //  title: '#',
        //  dataIndex: '',
        //  key: 'rowIndex',
        //  width: 47,
        //  align: 'center',
        //  customRender: function (t, r, index) {
        //    return parseInt(index) + 1
        //  },
        //},
        {
          title: this.$t('disp.jobName'),
          dataIndex: 'jobClassName',
        },
        {
          title: this.$t('disp.cronExpression'),
          dataIndex: 'cronExpression',
        },
        {
          title: this.$t('disp.parameter'),
          dataIndex: 'parameter',
        },
        {
          title: this.$t('disp.note'),
          customRender: function (t, r, index) {
            return <span style="white-space: pre-wrap;">{r.description}</span>
          },
        },
        {
          title: this.$t('disp.status'),
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'customRenderStatus' },
          width: 120,
          // filterMultiple: false,
          // filters: [
          //   { text: '実行中', value: '0' },
          //   { text: '未起動', value: '-1' }
          // ]
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/sys/quartzJob/list',
        delete: '/sys/quartzJob/delete',
        deleteBatch: '/sys/quartzJob/deleteBatch',
        pause: '/sys/quartzJob/pause',
        resume: '/sys/quartzJob/resume',
        exportXlsUrl: 'sys/quartzJob/exportXls',
        importExcelUrl: 'sys/quartzJob/importExcel',
        execute: 'sys/quartzJob/execute',
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },

  methods: {
    //タイムタスクを一時停止
    pauseJob: function (record) {
      if (this.loading) {
        return
      } else {
        // ローディング開始
        this.loading = true
      }

      getAction(this.url.pause, { jobClassName: record.jobClassName })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, true)
          } else {
            this.$message.warning(this.$t(res.message))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // タイムタスクをもとに戻す
    resumeJob: function (record) {
      if (this.loading) {
        return
      } else {
        // ローディング開始
        this.loading = true
      }

      getAction(this.url.resume, { jobClassName: record.jobClassName })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, true)
          } else {
            this.$message.warning(this.$t(res.message))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // タイムタスクを直ちに実行
    executeImmediately(record) {
      if (this.loading) {
        return
      } else {
        // ローディング開始
        this.loading = true
      }

      getAction(this.url.execute, { id: record.id })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, true)
          } else {
            this.$message.warning(this.$t(res.message))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style scoped></style>
